// //@ts-nocheck
// "use client";

// import { useEffect, useRef, useState } from "react";
// import styles from "./slider.module.css";
// import { GoDotFill } from "react-icons/go";
// import clsx from "clsx";
// import { HiArrowRight } from "react-icons/hi2";
// import Title from "./title";
// import Description from "./description";
// import { slugBuilder } from "../../utils/slug-builder";
// import DescriptionSpecial from "./description-special";
// import { FaLinkedin } from "react-icons/fa";
// import Image from "next/image";
// import useRoutePush from "../../utils/routerPush";
// import getExpirationFromUrl from "../../utils/check-image-expiry";
// import { getSignedUrl } from "../../utils/useSignedUrl";

// export default function Slider({ passedFunction = undefined, autoSign = true,imageList = null, title = "", description = "", mode = "rounded", delay = 3500, vxiContent = null, embed = null, hubSpotLink = null, link = "", place = "", bio = ""}) {
//     const sliderRef = useRef<HTMLDivElement | null>(null);
//     const wrapperRef = useRef<HTMLDivElement | null>(null);
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isHovered, setIsHovered] = useState(false);
//     const [aspectRatio, setAspectRatio] = useState(16 / 9);
//     const [isMobile, setIsMobile] = useState(false);
//     const [open, setOpen] = useState("");
//     const routePush = useRoutePush();

//     const checkScreenSize = () => {
//         setIsMobile(window.innerWidth <= 801);
//         setOpen("");
//     };

//     useEffect(() => {
//         checkScreenSize();
//         window.addEventListener("resize", checkScreenSize);
//         return () => window.removeEventListener("resize", checkScreenSize);
//     }, []);

//     useEffect(() => {
//         const slider = sliderRef.current;
//         if (!slider || imageList?.length === 0) return;
//         const autoScroll = () => {
//             setCurrentIndex((prevIndex) => {
//                 const newIndex = (prevIndex + 1) % imageList?.length;
//                 const scrollAmount = newIndex * slider.clientWidth;

//                 slider.scrollTo({
//                     left: scrollAmount,
//                     behavior: "smooth",
//                 });

//                 return newIndex;
//             });
//         };

//         const interval = setInterval(autoScroll, delay);
//         return () => clearInterval(interval);
//     }, [imageList?.length, delay]);

//     const [processedList, setProcessedList] = useState([]);

//     useEffect(() => {
//         const updateImageList = async () => {
//             const updatedImages = await Promise.all(
//                 imageList.map(async (img) => {
//                     const signedUrl = getSignedUrl(img);
//                     return signedUrl || img;
//                 })
//             );

//             setProcessedList(updatedImages);
//         };

//         if (imageList?.length && autoSign) {
//             updateImageList();
//         } else {
//             setProcessedList(imageList);
//         }
//     }, [imageList]);

//     useEffect(() => {
//         const updateAspectRatio = () => {
//             if (wrapperRef.current) {
//                 const { clientWidth, clientHeight } = wrapperRef.current;
//                 if (clientHeight > 0) {
//                     setAspectRatio(clientWidth / clientHeight);
//                 }
//             }
//         };
//         updateAspectRatio();
//     }, []);

//     const detectFileType = (src: string): 'image' | 'video' | 'unknown' => {
//         try {
//             // Remove query string if present
//             const cleanUrl = src.split('?')[0];
//             const extension = cleanUrl.split('.').pop()?.toLowerCase();

//             if (!extension) return 'unknown';
//             if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) return 'image';
//             if (['mp4', 'avi', 'mov', 'webm'].includes(extension)) return 'video';

//             return 'unknown';
//         } catch {
//             return 'unknown';
//         }
//     };

//     const handleClick = (e, href, more) => {
//         const isLinkedIn = href?.includes("linkedin.com");

//         if (isMobile) {
//             if (!isHovered) {
//                 e.preventDefault();
//                 setIsHovered(true);
//                 return;
//             } else {
//                 setIsHovered(false);
//                 if (!href) return;

//                 if (more === "know-more") {
//                     routePush(href);
//                 } else if (more === "know-more-blank") {
//                     // console.log(isMobile, more, bio.length);
//                     if (bio.length !== 0) {
//                         passedFunction();
//                     } else {
//                         routePush(href);
//                     }
//                 }

//                 return;
//             }
//         }
//         if (!href && !bio) return;
//         if (more === "know-more" || more === "more") {
//             routePush(href);
//         } else if (more === "know-more-blank" || more === "more-blank") {
//             if (!bio){
//                 routePush(href);
//             }else{
//                 passedFunction();
//             }
//         }
//         if (!href) return;
//     };    

//     return (
//         <div
//             ref={wrapperRef}
//             className={clsx(styles["slider-wrapper"], { [styles.round]: mode === "rounded" }, {[styles.hovered] : isHovered})}
//             onMouseEnter={() => !isMobile && setIsHovered(true)}
//             onMouseLeave={() => !isMobile && setIsHovered(false)}
//         >
//             <div ref={sliderRef} className={styles["slider-container"]}>
//                 {processedList && !embed && (processedList.map((slide, j) => {
//                 {/* {imageList && !embed && (imageList.map((slide, j) => { */}
//                     const type = detectFileType(slide);
//                     return (
//                         <div key={j} className={styles["slide"]}>
//                             {type === "image" ? (
//                                 <Image
//                                     src={slide}
//                                     alt={title} style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         objectFit: "cover",
//                                         aspectRatio: aspectRatio,
//                                     }}
//                                     width={1080}
//                                     height={1080}
//                                     placeholder="blur"
//                                     blurDataURL="/vxilogo.svg"
//                                     loading="lazy"
//                                 />
//                             ) : type === "video" ? (
//                                 <video
//                                     src={slide}
//                                     autoPlay
//                                     loop
//                                     muted
//                                     playsInline
//                                     style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         objectFit: "cover",
//                                         aspectRatio: aspectRatio
//                                     }}
//                                 >
//                                     Your browser does not support the video tag.
//                                 </video>
//                             ) : null}
//                         </div>
//                     );
//                 }))}
//                 {embed && (
//                     <div className={styles['video-wrapper']}>
//                         <iframe style={!embed.title && !embed.description ? { width: "100%", height: "100%", objectFit: "cover", aspectRatio } : {}} src={embed.url.replace("watch?v=", "embed/")} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
//                         <Title title={embed.title} />
//                         <Description description={embed.description} />
//                     </div>
//                 )}
//             </div>

//             {vxiContent ? (
//                 <div className={clsx(styles["slider-details"], {[styles.pointer] :  hubSpotLink ?? `/${slugBuilder(vxiContent.sections, null, vxiContent.title)}`})} onClick={(e) => handleClick(e, hubSpotLink ?? `/${slugBuilder(vxiContent.sections, null, vxiContent.title)}`, "more")}>
//                     {isHovered ? (
//                         <>
//                             <div className="sectionName">{vxiContent.types}</div>
//                             <h2 className={clsx(styles["slider-title"], {
//                                 [styles.menu]: place === "menu",
//                                 [styles["long-msg"]]: vxiContent.title.length > 80,
//                                 [styles["extra-long-msg"]]: vxiContent.title.length > 100
//                             })}>{vxiContent.title}</h2>
//                             <div className={styles["know-more"]} 
//                                 // href={hubSpotLink ?? `/${slugBuilder(vxiContent.sections, null, vxiContent.title)}`}
//                                 onClick={(e) => handleClick(e, hubSpotLink ?? `/${slugBuilder(vxiContent.sections, null, vxiContent.title)}`, "know-more")}
//                             >
//                                 Know more
//                                 <div className={styles["right-arrow"]}>
//                                     <HiArrowRight fontSize={18} color="black" />
//                                 </div>
//                             </div>
//                         </>
//                     ) : (
//                         <>
//                             <div className="sectionName">{vxiContent.sections}</div>
//                             <h2 className={clsx(styles["slider-title"], {
//                                 [styles.menu]: place === "menu",
//                                 [styles["long-msg"]]: vxiContent.title.length > 50,
//                                 [styles["extra-long-msg"]]: vxiContent.title.length > 80,
//                                 [styles["paragraph"]]: vxiContent.title.length > 110
//                             })}>{vxiContent.title}</h2>
//                             {imageList.length === 1 && (<div className={styles["godot"]}>
//                                 <GoDotFill color={"white"} size={15} />
//                             </div>)}
//                         </>
//                     )}
//                 </div>
//             ) : (
//                 title !== "" && (
//                     <div
//                         className={clsx(styles["slider-details"], {[styles.pointer] : link || bio})}
//                         // href={link}
//                         onClick={(e) => handleClick(e, link, "more-blank")}
//                     >
//                         {isHovered ? (
//                             <>
//                                 <h2 className={clsx(styles["slider-title"], {
//                                     [styles.menu]: place === "menu",
//                                     [styles["long-msg"]]: title.length > 50,
//                                     [styles["extra-long-msg"]]: title.length > 80,
//                                     [styles["paragraph"]]: title.length > 110
//                                 })}>{title}</h2>
//                                 <div className={styles["slider-desc"]}>
//                                     <DescriptionSpecial description={description} />
//                                 </div>
//                                 {bio && (
//                                     <div className={styles["know-more"]} onClick={(e) => handleClick(e, link ?? "test", "know-more-blank")}>
//                                         <p>Know more</p>
//                                         <div className={styles["right-arrow"]}>
//                                             <HiArrowRight fontSize={18} color="black" />
//                                         </div>
//                                     </div>
//                                 )}
//                             </>
//                         ) : (
//                             <>
//                                 <h2 className={clsx(styles["slider-title"], {
//                                     [styles.menu]: place === "menu",
//                                     [styles["long-msg"]]: title.length > 50,
//                                     [styles["extra-long-msg"]]: title.length > 80,
//                                     [styles["paragraph"]]: title.length > 110
//                                 })}>{title}</h2>
//                                 <div className={styles["godot"]}>
//                                     <GoDotFill color={"white"} size={15} />
//                                 </div>
//                             </>
//                         )}
//                     </div>
//                 )
//             )}

//             {imageList?.length > 1 && (
//                 <div className={styles["tracker-container"]}>
//                     {imageList.map((_, j) => (
//                         <GoDotFill
//                             key={j}
//                             color={j === currentIndex ? "white" : "lightgray"}
//                             size={15}
//                         />
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// }
//@ts-nocheck
"use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import styles from "./slider.module.css";
import { getSignedUrl } from "../../utils/useSignedUrl";
import { GoDotFill } from "react-icons/go";
import Link from "next/link";
import { slugBuilder } from "../../utils/slug-builder";
import clsx from "clsx";
import { HiArrowRight } from "react-icons/hi2";
import Title from "./title";
import Description from "./description";

export default function Slider({
    imageList = [],
    autoSign = true,
    delay = 3500,
    embed = null,
    staticScale = false,
    split = false
}) {
    const sliderRef = useRef(null);
    const wrapperRef = useRef(null);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [aspectRatio, setAspectRatio] = useState(16 / 9);
    const [processedList, setProcessedList] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // ===== DETECT MOBILE =====
    useEffect(() => {
        const check = () => {
            setIsMobile(window.innerWidth <= 801);
        };

        check();
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, []);

    // ===== AUTO SIGN =====
    useEffect(() => {
        let isMounted = true;
        const processImages = async () => {
            if (!imageList?.length) {
                setProcessedList([]);
                return;
            }

            if (!autoSign) {
                setProcessedList(imageList);
                return;
            }

            try {
                const signed = await Promise.all(
                    imageList.map(async (img) => {
                        try {
                            const signedUrl = await getSignedUrl(img);
                            return signedUrl || img;
                        } catch {
                            return img;
                        }
                    })
                );

                if (isMounted) setProcessedList(signed);
            } catch {
                if (isMounted) setProcessedList(imageList);
            }
        };

        if (!embed) processImages();

        return () => {
            isMounted = false;
        };
    }, [imageList, autoSign]);

    // ===== AUTO SLIDE =====
    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider || processedList.length === 0) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => {
                const next = (prev + 1) % processedList.length;

                slider.scrollTo({
                    left: next * slider.clientWidth,
                    behavior: "smooth",
                });

                return next;
            });
        }, delay);

        return () => clearInterval(interval);
    }, [processedList.length, delay]);

    // ===== SYNC INDEX WITH SCROLL =====
    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;

        const handleScroll = () => {
            const index = Math.round(
                slider.scrollLeft / slider.clientWidth
            );
            setCurrentIndex(index);
        };

        slider.addEventListener("scroll", handleScroll);

        return () => {
            slider.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // ===== ASPECT RATIO =====
    useEffect(() => {
        const updateAspectRatio = () => {
            if (!wrapperRef.current) return;

            const { clientWidth, clientHeight } = wrapperRef.current;
            if (clientHeight > 0) {
                setAspectRatio(clientWidth / clientHeight);
            }
        };

        updateAspectRatio();
        window.addEventListener("resize", updateAspectRatio);

        return () => window.removeEventListener("resize", updateAspectRatio);
    }, []);

    // ===== FILE TYPE =====
    const detectFileType = (src) => {
        const ext = src.split("?")[0].split(".").pop()?.toLowerCase();

        if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "image";
        if (["mp4", "webm", "mov"].includes(ext)) return "video";
        return "unknown";
    };

    // ===== MOBILE TAP BEHAVIOR =====
    const handleClick = (e) => {
        if (!isMobile) return;

        if (!isHovered) {
            e.preventDefault();
            setIsHovered(true);
        } else {
            setIsHovered(false);
        }
    };

    return (
        <div
            ref={wrapperRef}
            className={`${styles["slider-wrapper"]} ${isHovered ? styles["hovered"] : ""
                } ${staticScale ? styles["static"] : ""}`}
            onMouseEnter={() => !isMobile && !staticScale && setIsHovered(true)}
            onMouseLeave={() => !isMobile && !staticScale && setIsHovered(false)}
            onClick={handleClick}
        >
            {/* SLIDER */}
            <div ref={sliderRef} className={styles["slider-container"]}>
                {!embed && processedList.map((slide, i) => {
                    const type = detectFileType(slide);

                    return (
                        <div key={i} className={styles["slide"]}>
                            {type === "image" ? (
                                <Image
                                    src={slide}
                                    alt=""
                                    width={1080}
                                    height={1080}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        aspectRatio,
                                    }}
                                />
                            ) : type === "video" ? (
                                <video
                                    src={slide}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    controls={split}
                                    style={{
                                        width: "100%",
                                        height: split ? "auto" : "100%",
                                        objectFit: split ? "" : "cover",
                                        aspectRatio,
                                    }}
                                />
                            ) : null}
                        </div>
                    );
                })}
                {embed && (
                    <div className={styles['video-wrapper']}>
                        <iframe style={!embed.title && !embed.description ? { width: "100%", height: "100%", objectFit: "cover", aspectRatio } : {}} src={embed.url.replace("watch?v=", "embed/")} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                        <Title title={embed.title} />
                        <Description description={embed.description} />
                    </div>
                )}
            </div>

            {/* TRACKER */}
            {processedList.length > 1 && (
                <div className={styles["tracker-container"]}>
                    {processedList.map((_, j) => (
                        <GoDotFill
                            key={j}
                            color={j === currentIndex ? "white" : "lightgray"}
                            size={15}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export function BlogCard({
    imageList = [],
    autoSign = true,
    delay = 3500,
    vxiContent,
    title = "",
    description = "",
    link,
    bio,
    place,
    hubSpotLink,
    passedFunction = null
}) {
    const [isHovered, setIsHovered] = useState(false);

    const resolvedHref = vxiContent
        ? (hubSpotLink ?? `/${slugBuilder(vxiContent?.sections, null, vxiContent?.title)}`)
        : (link || "");

    const hasHref = typeof resolvedHref === "string" && resolvedHref.trim().length > 0;

    const handleClick = (e, url, type) => {
        if (passedFunction) {
            e.preventDefault();
            passedFunction();
            return;
        }

        if (!url) {
            e.preventDefault();
        }
    };

    const details = (
        <>
            {vxiContent ? (
                <div
                    className={clsx(styles["slider-details"], {
                        [styles.pointer]: hubSpotLink ?? `/${slugBuilder(vxiContent.sections, null, vxiContent.title)}`
                    })}
                    onClick={(e) =>
                        handleClick(
                            e,
                            hubSpotLink ?? `/${slugBuilder(vxiContent.sections, null, vxiContent.title)}`,
                            "more"
                        )
                    }
                >
                    {isHovered ? (
                        <>
                            <div className="sectionName">{vxiContent.types}</div>

                            <h2
                                className={clsx(styles["slider-title"], {
                                    [styles.menu]: place === "menu",
                                    [styles["long-msg"]]: vxiContent.title.length > 80,
                                    [styles["extra-long-msg"]]: vxiContent.title.length > 100
                                })}
                            >
                                {vxiContent.title}
                            </h2>

                            <div
                                className={styles["know-more"]}
                                onClick={(e) =>
                                    handleClick(
                                        e,
                                        hubSpotLink ?? `/${slugBuilder(vxiContent.sections, null, vxiContent.title)}`,
                                        "know-more"
                                    )
                                }
                            >
                                Know more
                                <div className={styles["right-arrow"]}>
                                    <HiArrowRight fontSize={18} color="black" />
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="sectionName">{vxiContent.sections}</div>

                            <h2
                                className={clsx(styles["slider-title"], {
                                    [styles.menu]: place === "menu",
                                    [styles["long-msg"]]: vxiContent.title.length > 50,
                                    [styles["extra-long-msg"]]: vxiContent.title.length > 80,
                                    [styles["paragraph"]]: vxiContent.title.length > 110
                                })}
                            >
                                {vxiContent.title}
                            </h2>

                            {imageList.length === 1 && (
                                <div className={styles["godot"]}>
                                    <GoDotFill color="white" size={15} />
                                </div>
                            )}
                        </>
                    )}
                </div>
            ) : (
                title !== "" && (
                    <div
                        className={clsx(styles["slider-details"], {
                            [styles.pointer]: link || bio
                        })}
                        onClick={(e) => handleClick(e, link, "more-blank")}
                    >
                        {isHovered ? (
                            <>
                                <h2
                                    className={clsx(styles["slider-title"], {
                                        [styles.menu]: place === "menu",
                                        [styles["long-msg"]]: title.length > 50,
                                        [styles["extra-long-msg"]]: title.length > 80,
                                        [styles["paragraph"]]: title.length > 110
                                    })}
                                >
                                    {title}
                                </h2>

                                <div className={styles["slider-desc"]}>
                                    {description}
                                </div>

                                {bio && (
                                    <div
                                        className={styles["know-more"]}
                                        onClick={(e) =>
                                            handleClick(e, link ?? "test", "know-more-blank")
                                        }
                                    >
                                        <p>Know more</p>
                                        <div className={styles["right-arrow"]}>
                                            <HiArrowRight fontSize={18} color="black" />
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <h2
                                    className={clsx(styles["slider-title"], {
                                        [styles.menu]: place === "menu",
                                        [styles["long-msg"]]: title.length > 50,
                                        [styles["extra-long-msg"]]: title.length > 80,
                                        [styles["paragraph"]]: title.length > 110
                                    })}
                                >
                                    {title}
                                </h2>

                                <div className={styles["godot"]}>
                                    <GoDotFill color="white" size={15} />
                                </div>
                            </>
                        )}
                    </div>
                )
            )}
            <Slider imageList={imageList} />
        </>
    );

    if (hasHref) {
        return (
            <Link
                href={resolvedHref}
                className={`${styles["slider-wrapper"]} ${isHovered ? styles["hovered"] : ""}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {details}
            </Link>
        );
    }

    return (
        <div
            className={`${styles["slider-wrapper"]} ${isHovered ? styles["hovered"] : ""}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {details}
        </div>
    );
}